import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a63fffe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "header-menu__icon"
}

import { getCurrentInstance, onMounted, ref, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Fold, Expand, User, Monitor, Tickets, Notebook, ScaleToOriginal } from '@element-plus/icons-vue'
import { IMenuParams } from '@/types/myProfile'
import { useMainStore } from '@/stores/main'
import { storeToRefs } from 'pinia'
import { getMenuTitle } from '@/utils/lang'

export default /*#__PURE__*/_defineComponent({
  __name: 'leftMenu',
  setup(__props, { expose }) {

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
// 面包屑
const store = useMainStore()
const { breadcrumb, activePage } = storeToRefs(store)

// const props = defineProps({
//   // 是否收缩菜单
//   isFold: { type: Boolean, default: false }
// })
const MenuOpeneds = ['applicationForm', 'entrustedMyApplication', 'NBapplicationMyApplication', 'communicationMyApplication', 'communicationmyPVOCApplication', 'internationalMyApplication']
// 跳转页面
const route = useRoute()
const router = useRouter()
const toPage = (parent: any, data?: any) => {
  breadcrumb.value = data ? data.breadcrumbList : parent.breadcrumbList
  router.push({
    path: data ? data.path : parent.path
  })
}
// 获取菜单信息
const menuList = ref<IMenuParams[] | []>([])
// 菜单收缩
const isFold = ref<boolean>(false)
const onShrinkMenu = () => {
  isFold.value = !isFold.value
}
// 需要隐藏折叠图标的页面
const flodPage = ['policyInfo', 'publicFile', 'myProfileInfo']
const isShowFlod = ref(true)
// 是否显示折叠菜单图标
const onShowFlodIcon = () => {
  if (route.name) {
    const pageName: any = route.name
    isShowFlod.value = flodPage.indexOf(pageName) === -1
  }
}
onMounted(() => {
  menuList.value = store.leftMenuList
  onShowFlodIcon()
})
watchEffect(() => {
  menuList.value = store.leftMenuList
})

// 导出方法，便于引用组件使用
expose({ onShowFlodIcon })

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": _unref(activePage),
      class: "el-menu-vertical-demo",
      collapse: isFold.value,
      "default-openeds": MenuOpeneds
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (!item.children || !item.children.length)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: item.name,
                  onClick: ($event: any) => (toPage(item)),
                  "default-active": _unref(activePage)
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getMenuTitle)(item,_unref(t))), 1)
                  ]),
                  default: _withCtx(() => [
                    (item.meta.icon === 'el-icon-monitor')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Monitor), { class: "icon__menu" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (item.meta.icon === 'el-icon-notebook')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Notebook), { class: "icon__menu" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (item.meta.icon === 'el-icon-user')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(User), { class: "icon__menu" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["index", "onClick", "default-active"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 1,
                  index: item.name
                }, {
                  title: _withCtx(() => [
                    (item.meta.icon === 'el-icon-tickets')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Tickets), { class: "icon__menu" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (item.meta.icon === 'el-icon-scale-to-original')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ScaleToOriginal), { class: "icon__menu" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_unref(getMenuTitle)(item,_unref(t))), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (data, ind) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        index: data.name,
                        onClick: ($event: any) => (toPage(item, data)),
                        key: ind,
                        "default-active": _unref(activePage)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getMenuTitle)(data,_unref(t))), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick", "default-active"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "collapse"]),
    (isShowFlod.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!isFold.value)
            ? (_openBlock(), _createBlock(_unref(Fold), {
                key: 0,
                style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
                onClick: onShrinkMenu
              }))
            : _createCommentVNode("", true),
          (isFold.value)
            ? (_openBlock(), _createBlock(_unref(Expand), {
                key: 1,
                style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
                onClick: onShrinkMenu
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})